import React, { useReducer } from 'react';
import { Grid, Typography, InputLabel, RadioGroup, FormControlLabel, Radio, Checkbox, FormHelperText, Box, IconButton, Chip, Avatar } from '@material-ui/core';
import { reducer, initState } from '../../../Reducer/action';
import { SecondaryButton, TextBox, YesNoButton, SlideToggle, Dialogs, DialogTitles, DialogContents, DialogsActions } from '../../../../Core/FormInput/index';
import { useState, useCallback } from 'react';
import CommonGijgoGrid from '../../../../Core/Controls/GijgoGrid/index';
import moment from 'moment';
import SelectBox from './../../../../Core/FormInput/SelectBox';
import DataGridComp from '../../../../Core/Grid';
import { GridOverlay } from '@material-ui/data-grid';
import { getStatusDropdown, postVehicleStatus, getVehicleStatusID } from '../../../../Core/Service/communicator-service';
import { useEffect } from 'react';
import { useContext } from 'react';
import AppContext from '../../../../App/AppContext';
import VehicleStatusStepper from '../VehicleStatusStepper/vehicleStatusStepper';
import CloseIcon from '@material-ui/icons/Close';
import BuildIcon from '@material-ui/icons/Build';
import LogHistory from '../OpenActionLogs/logHistory';
import ApprovalDetailsModal from './approvalDetailsModal';
import DialogComp from '../../../../Core/Modal/dialogModal';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { getTCards_GetExistingTCards } from '../../../../Core/Service/checkInRole';
import ExistingCardsList from '../../../CheckIn/Dashboard/ExistingCardsList';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import TCardDashboardModal from '../../T-card/Dashboard/T-cardModal';
import TcardNotesModal from '../../T-card/Dashboard/T-cardNotes/T-cardNotes';
import { SpeakerNotes, Link, Restore } from '@material-ui/icons';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';

const AddEditSiteVehicle = (props) => {
    let checkIsTcardReadonly = localStorage.getItem('_isTcardReadonly_') === 'true' ? true : false;

    const { showToast, showModal, userRoles } = useContext(AppContext);
    const [showTCardNotesModal, setShowTCardNotesModal] = useState(false);

    const isCustomer = userRoles.includes('customer');
    let isReadOnly = isCustomer;
    const { onClose } = props;
    const [state, setState] = useState({
        errors: {},
        partStatusList: [],
        vehicleStatusList: [],
        otherVehicleStatusList: [],
        partStatus: '',
        vehicleStatus: '',
        highPriority: false,
        isFMOrWarranty: false,
        isBreakdown: false,
        isNightShift: false,
        createTCard: true,
        stepperNumber: 0,
        stepperData: {},
        tCardsID: null,
        notesCount: null,
        technicians: []
    });
    const [isFirstTimeBreakDown, setIsFirstTimeBreakDown] = useState(false);
    const [existingTCards, setExistingTCards] = useState([]);
    const [isBtnLoader, setIsBtnLoader] = useState(false);

    const pullData = async () => {
        let getByIdRes = await getVehicleStatusID(props.headerRecordID, props.tCardID);
        let stepperData = getByIdRes.data?.jobProgressDate ? getByIdRes.data?.jobProgressDate[0] : {};
        let data = getByIdRes.data.list[0];
        if (getByIdRes?.success) {
            let CheckDate = data?.cancelledDate || data?.dateCollected;
            if (data?.isBreakdown) {
                setIsFirstTimeBreakDown(false);
            }
            setState((st) => ({
                ...st,
                headerRecordID: data?.headerRecordID,
                internalNotes: data?.internalNotes,
                partETA: data?.partETA,
                partStatus: data?.partStatus,
                vehicleDeliveryDate: data?.vehicleDeliveryDate,
                vehicleStatus: data?.tCardStatusID,
                workDetails: data?.workDetails,
                highPriority: data?.highPriority,
                stepperNumber: data?.stepperNumber,
                currentStepperNumber: data?.stepperNumber - 1,
                statusDesc: data?.status,
                bookedDate: data?.bookedDate,
                cancelledDate: data?.cancelledDate,
                dateCollected: data?.dateCollected,
                approvedOrderDate: data?.approvedOrderDate,
                stepperData: stepperData,
                isReadOnly: isReadOnly || CheckDate ? true : false,
                isFMOrWarranty: data?.isFMOrWarranty,
                isBreakdown: data?.isBreakdown,
                isNightShift: data?.isNightShift,
                tCardsID: data?.tCardsID || null,
                r2CJobReference: data?.r2CJobReference,
                bookingDate: data?.bookingDate,
                tCardStatusID: data?.tCardStatusID,
                technicianUserID: data.technicianUserID,
                notesCount: data.notesCount,

                motDate: data.motDate,
                motLocation: data.motLocation,
                createTCard: data.createTCard
            }));

            if (!data?.tCardsID) {
                let res = await getTCards_GetExistingTCards(null, props.headerRecordID);
                setExistingTCards(res.data?.tCards.map((q) => ({ ...q, isSelected: false, isChecBoxkDisabled: q.tCardsHeaderRecordID ? true : false })) || []);
            }
        }
    };

    useEffect(async () => {
        pullData();
    }, [props.headerRecordID, props.tCardID]);

    // useEffect(async () => {
    //     if (!state.tCardsID && props.headerRecordID) {
    //         // let res = await getTCards_GetExistingTCards(null, props.headerRecordID);
    //         // setExistingTCards(res.data?.tCards.map((q) => ({ ...q, isSelected: false, isChecBoxkDisabled: q.tCardsHeaderRecordID ? true : false })) || []);
    //     }
    // }, [props.headerRecordID]);

    const stepperModalOnClose = (res) => {
        res && pullData();
        res && props.onClose(true);
    };

    useEffect(async () => {
        if (state.vehicleStatus !== null && state.vehicleStatus !== undefined) {
            let res = await getStatusDropdown(state.vehicleStatus, props.tCardID);
            if (res.success) {
                setState((st) => ({
                    ...st,
                    partStatusList: res?.data?.partStatus,
                    vehicleStatusList: res?.data?.vehicleStatus,
                    otherVehicleStatusList: res?.data?.vehicleStatus.map((q) => {
                        if (q.smsText) {
                            q.smsText = q.smsText.replace('{reg}', `${props.reg}`);
                        }

                        return { ...q };
                    }),
                    technicians: res?.data?.technicians || []

                    // .filter((p) => p.id != state.vehicleStatus)
                }));
            }
        }
    }, [state.vehicleStatus]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            if (name == 'isBreakdown' && checked) {
                setIsFirstTimeBreakDown(true);
            } else {
                setIsFirstTimeBreakDown(false);
            }
            setState((st) => ({ ...st, [name]: checked }));
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const validation = () => {
        let { workDetails, vehicleStatus, partStatus } = state;
        let isValid = true;
        let errors = {};

        if (!workDetails) {
            isValid = false;
            errors.workDetails = 'Work Details is required';
        }
        // if (!vehicleStatus) {
        //     isValid = false;
        //     errors.vehicleStatus = 'Vehicle Status is required';
        // }
        // if (!partStatus) {
        //     isValid = false;
        //     errors.partStatus = 'Part Status is required';
        // }
        setState((st) => ({ ...st, errors: errors }));
        return isValid;
    };

    const handleSubmit = async () => {
        if (validation()) {
            setIsBtnLoader(true);
            let data = {
                headerRecordID: props.headerRecordID,
                workDetails: state.workDetails,
                createTCard: state.createTCard,
                // internalNotes: state.internalNotes,
                // vehicleStatus: state.vehicleStatus,
                // vehicleDeliveryDate: state.vehicleDeliveryDate,
                // partStatus: state.partStatus,
                // partETA: state.partETA,
                highPriority: state.highPriority,
                isFMOrWarranty: state.isFMOrWarranty,
                isBreakdown: state.isBreakdown,
                isNightShift: state.isNightShift,
                tCardID: state.selectedExistingTcardID,
                r2CJobReference: state.r2CJobReference || ''
            };

            let res = await postVehicleStatus(data);
            if (res.success) {
                showToast(`Vehicle Status Updated Successfully`);
                props.onClose(true, isFirstTimeBreakDown);
            } else {
                showToast(`Vehicle Status Failed To Update`);
            }
            setIsBtnLoader(false);
        }
    };

    const handleHistoryModal = (val) => {
        setState((st) => ({ ...st, history: true }));
    };
    const closeHistoryModal = (val) => {
        setState((st) => ({ ...st, history: false }));
    };
    const handleapprovalDetailModal = (val) => {
        setState((st) => ({ ...st, approvalDetailShow: true }));
    };
    const closeapprovalDetailModal = (val) => {
        setState((st) => ({ ...st, approvalDetailShow: false }));
    };

    const addActionLogHeaderComp = (ModalTitle) => {
        return (
            <Grid container>
                <Grid item>
                    <span>
                        Vehicle Status
                        {state.tCardsID && (
                            <Chip
                                style={{
                                    marginRight: 4,
                                    marginLeft: 7,
                                    color: state.notesCount > 0 ? 'white' : '',
                                    backgroundColor: state.notesCount > 0 ? 'green' : ''
                                }}
                                avatar={
                                    <Avatar>
                                        <SpeakerNotes
                                            style={{
                                                color: state.notesCount > 0 ? 'white' : '',
                                                backgroundColor: state.notesCount > 0 ? 'green' : ''
                                            }}
                                        />
                                    </Avatar>
                                }
                                label={`Notes`}
                                onClick={() => setShowTCardNotesModal(true)}
                            />
                        )}
                        {state.approvedOrderDate && (
                            <Chip
                                style={{ marginLeft: 10 }}
                                avatar={
                                    <Avatar>
                                        <AssignmentTurnedInIcon />
                                    </Avatar>
                                }
                                label="Approval Details"
                                onClick={handleapprovalDetailModal}
                            />
                        )}
                        {state.tCardsID && (
                            <Chip
                                style={{ marginLeft: 10 }}
                                avatar={
                                    <Avatar>
                                        <TextFieldsIcon />
                                    </Avatar>
                                }
                                label="Update T-Card"
                                onClick={onUpdateTCard}
                            />
                        )}
                    </span>
                </Grid>
            </Grid>
        );
    };

    const onJobSelect = (checked, tCardsID) => {
        let temp = [...existingTCards];
        let job = temp.find((d) => d.tCardsID === tCardsID);
        if (job) {
            temp.forEach((d) => (d.isSelected = false));
            job.isSelected = checked;
            temp = [...temp];
        }
        setState((prevState) => ({
            ...prevState,
            selectedExistingTcardID: checked ? tCardsID : undefined,
            selectedExistingTcard: checked ? job : null,
            createTCard: false
        }));
        setExistingTCards(temp);
    };

    const headerCreateTcardBtnFunc = (value) => {
        setState((prevState) => ({
            ...prevState,
            createTCard: value,
            selectedExistingTcardID: null
        }));
    };

    const onUpdateTCard = () => {
        setState((prevState) => ({
            ...prevState,
            showUpdateTCard: true
        }));
    };

    const onUpdateTCardClose = (cond, id, res) => {
        setState((prevState) => ({
            ...prevState,
            showUpdateTCard: false
            // tCardsID: null
        }));
        res && pullData();
    };

    const hideConfirmationModal = () => {
        setState((prevState) => ({
            ...prevState,
            showWarning: false
        }));
    };
    const ShowConfirmationModal = () => {
        if (validation()) {
            setState((prevState) => ({
                ...prevState,
                showWarning: true
            }));
        }
    };

    return (
        <Dialogs open={true} onClose={!props.isOnCloseBtnHide ? () => props.onClose(false) : null} maxWidth="xl" fullWidth>
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>{<DialogTitles>{addActionLogHeaderComp()}</DialogTitles>}</Box>
                {!props.isOnCloseBtnHide && (
                    <Box>
                        <IconButton onClick={() => props.onClose(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                )}
            </Box>
            <DialogContents className="hiddenScroll">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={state.tCardsID ? 12 : 8}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid container justify="space-between">
                                    <Grid item style={{ fontSize: 15, textAlign: 'left' }}>
                                        WIP No:&nbsp; <b> {props.wip}</b> &nbsp;&nbsp; Reg. No:&nbsp; <b> {props.reg}</b>
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <Grid item xs={4}>
                                            {/* <InputLabel shrink>R2C Job Reference</InputLabel> */}
                                            <TextBox
                                                placeholder="R2C Job Reference"
                                                id="outlined-multiline-static"
                                                variant="outlined"
                                                name="r2CJobReference"
                                                value={state.r2CJobReference}
                                                onChange={handleInput}
                                                disabled={state.isReadOnly}
                                                autoFocus={true}
                                            />
                                            {/* <FormHelperText error>{state.errors.workDetails}</FormHelperText> */}
                                        </Grid>
                                        <Grid item xs={8}>
                                            {' '}
                                            <Grid container justifyContent="flex-end">
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={state.highPriority} onChange={handleInput} name="highPriority" />}
                                                        label="Cash Job?"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={state.isFMOrWarranty} onChange={handleInput} name="isFMOrWarranty" />}
                                                        label="Is FM Or Warranty Job?"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={state.isBreakdown} onChange={handleInput} name="isBreakdown" />}
                                                        label="Is Breakdown Job?"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={state.isNightShift} onChange={handleInput} name="isNightShift" />}
                                                        label="Is Night Shift Job?"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <VehicleStatusStepper
                                    currentStatus={state.currentStepperNumber}
                                    vehicleStatusList={state.otherVehicleStatusList}
                                    headerRecordID={props.headerRecordID || state.headerRecordID}
                                    onClose={stepperModalOnClose}
                                    stepperData={state.stepperData}
                                    partStatusList={state.partStatusList}
                                    statusDesc={state.statusDesc}
                                    bookedDate={state.bookedDate}
                                    cancelledDate={state.cancelledDate}
                                    dateCollected={state.dateCollected}
                                    bookingDate={state.bookingDate}
                                    tCardID={state.tCardsID}
                                    tCardStatusID={state.tCardStatusID}
                                    technicians={state.technicians}
                                    technicianUserID={state.technicianUserID}
                                    state={state}
                                />
                            </Grid>

                            {/* <Grid item xs={12}>
                                <InputLabel shrink error>
                                    R2C Job Reference
                                </InputLabel>
                                <TextBox
                                    placeholder="R2C Job Reference"
                                    id="outlined-multiline-static"
                                    variant="outlined"
                                    name="r2CJobReference"
                                    value={state.r2CJobReference}
                                    onChange={handleInput}
                                    disabled={state.isReadOnly}
                                    autoFocus={true}
                                />
                                <FormHelperText error>{state.errors.workDetails}</FormHelperText>
                            </Grid> */}
                            <Grid item xs={12}>
                                <InputLabel shrink error>
                                    Work Details
                                </InputLabel>
                                <TextBox
                                    placeholder=" Work Details"
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    name="workDetails"
                                    value={state.workDetails}
                                    onChange={handleInput}
                                    disabled={state.isReadOnly}
                                    autoFocus={true}
                                />
                                <FormHelperText error>{state.errors.workDetails}</FormHelperText>
                            </Grid>
                        </Grid>
                    </Grid>
                    {!state.tCardsID && (
                        <Grid item xs={12} md={4}>
                            <ExistingCardsList
                                existingTCards={existingTCards}
                                onJobSelect={onJobSelect}
                                tableHeight={'310px'}
                                isHeaderCreateTcardBtnFunc={headerCreateTcardBtnFunc}
                                createTCard={state.createTCard}
                            />
                        </Grid>
                    )}
                </Grid>
            </DialogContents>
            {!state.isReadOnly && (
                <DialogsActions className="dialogActions">
                    <Grid item xs={!props.isOnCloseBtnHide ? 6 : 12}>
                        <SecondaryButton
                            className="Submitbtn"
                            fullWidth
                            onClick={state.createTCard && !state.tCardsID ? ShowConfirmationModal : handleSubmit}
                            disabled={state.isReadOnly}
                            isBtnLoader={isBtnLoader}
                        >
                            Submit
                        </SecondaryButton>
                    </Grid>
                    {!props.isOnCloseBtnHide && (
                        <Grid item xs={6}>
                            <SecondaryButton className="Submitbtn" fullWidth onClick={() => onClose(false)}>
                                Cancel
                            </SecondaryButton>
                        </Grid>
                    )}
                </DialogsActions>
            )}
            {state.history ? (
                <LogHistory
                    headerRecordID={props.headerRecordID}
                    reg={props.reg}
                    wip={props.wip}
                    onClose={() => closeHistoryModal(false)}
                    hideAddActionBtn={true}
                />
            ) : null}

            {state.approvalDetailShow ? (
                <DialogComp title={'Approval Details'} onClose={() => closeapprovalDetailModal(false)} fullWidth maxWidth="sm">
                    <ApprovalDetailsModal
                        headerRecordID={props.headerRecordID}
                        reg={props.reg}
                        wip={props.wip}
                        onClose={() => closeapprovalDetailModal(false)}
                        hideAddActionBtn={true}
                    />
                </DialogComp>
            ) : null}
            {state.showUpdateTCard && (
                // <DialogComp title={'opopop'} maxWidth="xl" onClose={handleClose} fullWidth overflow="auto" fullScreen>
                <TCardDashboardModal id={state.tCardsID} onClose={onUpdateTCardClose} />
                // </DialogComp>
            )}
            {showTCardNotesModal && (
                <TcardNotesModal
                    tCardsID={state.tCardsID}
                    onClose={(shouldRefresh = false) => {
                        setShowTCardNotesModal(false);
                        if (shouldRefresh) {
                            pullData();
                        }
                    }}
                    maxWidth="md"
                    isReadOnly={checkIsTcardReadonly}
                />
            )}
            {state.showWarning ? (
                <DialogComp title="Warning" onClose={hideConfirmationModal} maxWidth="sm">
                    <ConfirmationModal
                        message={'Are you sure you want to create a new T-card?'}
                        handleSubmit={handleSubmit}
                        handleCancel={hideConfirmationModal}
                    />
                </DialogComp>
            ) : null}
        </Dialogs>
    );
};

export default AddEditSiteVehicle;
